// GENERATED by tools/build_score_ts.py from the transcription in
// nsm-sight-reading/scores/src/left-hand-lullaby.json — do not edit here.
// Every note carries an absolute start and duration in quarter notes, so
// the engraving and the playback clock cannot disagree about timing.
import type { Score } from "@/courses/sight-reading/types";

export const leftHandLullaby: Score = {
  slug: "left-hand-lullaby",
  n: 26,
  title: "Left Hand Lullaby",
  composer: "Jason Zac",
  rights: "original",
  publicSafe: true,
  key: "F",
  fifths: -1,
  time: [3, 4],
  tempo: 76,
  staves: 1,
  clefs: ["bass"],
  bars: 8,
  barQuarters: 3.0,
  lowest: 50,
  highest: 60,
  hasLyrics: false,
  jasonNote: "Three beats in a bar, in the left hand, with one flat to watch for. Play it softly and let each dotted note ring for its full three beats before you move.",
  teaches: ["3/4 in the bass clef", "the dotted minim", "one flat \u2014 B flat", "playing softly"],
  art: "/sight-reading/art/left-hand-lullaby.jpg",
  artRights: "stock-free",
  background: "/sight-reading/bg/left-hand-lullaby.jpg",
  newForThisEdition: true,
  fillsGap: "Nothing in the printed book reads 3/4 in the bass clef.",
  notes: [
    { bar: 1, hand: "rh", start: 0.0, dur: 2.0, midi: 53, pitch: "F3", d: "half" },
    { bar: 1, hand: "rh", start: 2.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter" },
    { bar: 2, hand: "rh", start: 3.0, dur: 3.0, midi: 60, pitch: "C4", d: "half", dot: true },
    { bar: 3, hand: "rh", start: 6.0, dur: 2.0, midi: 58, pitch: "Bb3", d: "half" },
    { bar: 3, hand: "rh", start: 8.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter" },
    { bar: 4, hand: "rh", start: 9.0, dur: 3.0, midi: 55, pitch: "G3", d: "half", dot: true },
    { bar: 5, hand: "rh", start: 12.0, dur: 2.0, midi: 57, pitch: "A3", d: "half" },
    { bar: 5, hand: "rh", start: 14.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 6, hand: "rh", start: 15.0, dur: 2.0, midi: 53, pitch: "F3", d: "half" },
    { bar: 6, hand: "rh", start: 17.0, dur: 1.0, midi: 52, pitch: "E3", d: "quarter" },
    { bar: 7, hand: "rh", start: 18.0, dur: 2.0, midi: 50, pitch: "D3", d: "half" },
    { bar: 7, hand: "rh", start: 20.0, dur: 1.0, midi: 52, pitch: "E3", d: "quarter" },
    { bar: 8, hand: "rh", start: 21.0, dur: 3.0, midi: 53, pitch: "F3", d: "half", dot: true },
  ],
};
